module.exports = __webpack_public_path__ + "img/part3-2.0d3e2298.png";